import { EditorState, strCompareLowerCase } from "@common/Common";
import { ValidationError } from "@common/types";
import { RawCriterionWeight } from "@Criteria/Model";
import { CriterionWeightReadModel, WeightsReadModel, WeightsSetEditorReadModel } from "@Criteria/Weights/Domain/readmodels";

export class WeightsSetEditorViewModel
{
    editorState: EditorState = EditorState.Closed;
    initialized: boolean = false;

    weightsSetId: number | null = null;
    name: string | null = null;
    criteria: WeightsSetEditorCriterionViewModel[] = [];
    
    errors: ValidationError[] = [];    

    showCreator(name: string)
    {
        this.initialized = false;

        this.weightsSetId = null;
        this.name = name;
        this.criteria = [];
        this.errors = [];

        this.editorState = EditorState.Creator;
    }

    showEditor(weightsSetId: number, name: string)
    {
        this.initialized = false;

        this.weightsSetId = weightsSetId;
        this.name = name;
        this.criteria = [];
        this.errors = [];

        this.editorState = EditorState.Editor;
    }

    close()
    {
        this.editorState = EditorState.Closed;

        this.initialized = false;
        this.weightsSetId = null;
        this.name = null;
        this.criteria = [];

        this.errors = [];
    }

    setData(data: WeightsSetEditorReadModel)
    {
        this.criteria = data.Weights.map(w => new WeightsSetEditorCriterionViewModel(w)).sort((a, b) => strCompareLowerCase(a.path, b.path));
        this.initialized = true;
    }

    setRecalculatedWeights(rm: WeightsReadModel)
    {
        this.criteria.forEach(curr =>
        {
            const incoming = rm.Weights.find(w => w.CriterionId === curr.id);
            curr.globalWeight = incoming!.GlobalWeightPercent;
            curr.inputValue = incoming!.LocalWeightPercent;
            curr.localWeight = incoming!.LocalWeightPercent;
        });
    }

    displayValidationErrors(errors: ValidationError[])
    {
        this.errors = errors;
    }
}

export class WeightsSetEditorCriterionViewModel
{
    id: number;
    name: string;
    path: string;
    isGoal: boolean;

    inputValue: number | null = null;
    localWeight: number | null = null;
    globalWeight: number | null = null;
    constructor(data: CriterionWeightReadModel)
    {
        this.id = data.CriterionId;
        this.name = data.Name;
        this.path = data.Path;
        this.isGoal = data.ParentId == null;
        this.inputValue = data.LocalWeightPercent;
        this.localWeight = data.LocalWeightPercent;
        this.globalWeight = data.GlobalWeightPercent;
    }

    update(data: CriterionWeightReadModel)
    {
        this.inputValue = data.LocalWeightPercent;
        this.localWeight = data.LocalWeightPercent;
        this.globalWeight = data.GlobalWeightPercent;
    }
}


export class WeightsSetEditorCreateWeightsSetEventPayload
{
    name: string;
    weights: RawCriterionWeight[];

    constructor(name: string, weights: RawCriterionWeight[])
    {
        this.name = name;
        this.weights = weights;
    }
}

export class WeightsSetEditorUpdateWeightsSetEventPayload
{
    weightsSetId: number;
    name: string;
    weights: RawCriterionWeight[];

    constructor(weightsSetId: number, name: string, weights: RawCriterionWeight[])
    {
        this.weightsSetId = weightsSetId;
        this.name = name;
        this.weights = weights;
    }
}

export class WeightsSetEditorNormalizeWeightsEventPayload
{
    weights: RawCriterionWeight[];

    constructor(weights: RawCriterionWeight[])
    {
        this.weights = weights;
    }
}